import Service 			from "./../../Libs/Service";

let Animation = new Service({

	Name: "Animation",

	Libraries: [],

	Events: {

	},

	Actions: {

		"Animations": function(animations, data) {

			if (data.AnimationsProjectId) {

				this.setAnimations(animations);

				//Первоначальная загрузка анимаций всех версий проекта
				Broadcast.call("Project Animations Loaded");

			} else if (data.AnimationsVersionId) {

				this.setAnimations(animations);

				//Первоначальная загрузка анимаций одной версии (дублирование версии или создание из шаблона)
				Broadcast.call("Version Animations Loaded");

			}

		},

		"Animation": function(animation, data) {

			let oldAnimation = this.AnimationsByVersionByCodename[data.AnimationVersionId]?.[data.AnimationCodename];

			this.setAnimation(data.AnimationVersionId, data.AnimationScreenCodename, animation);

			this.detectAnimationChanges(oldAnimation, animation);

		},

		"AnimationSteps": function(animationSteps, data) {

			if (data.AnimationStepsProjectId) {

				this.setAnimationSteps(animationSteps);

				//Первоначальная загрузка анимаций всех версий проекта
				Broadcast.call("Project Animation Steps Loaded");

			} else if (data.AnimationStepsVersionId) {

				this.setAnimationSteps(animationSteps);

				//Первоначальная загрузка анимаций одной версии (дублирование версии или создание из шаблона)
				Broadcast.call("Version Animation Steps Loaded");

			}

		},

		"AnimationStep": function(animationStep, data) {

			let oldAnimationStep = this.AnimationStepsByScreenByCodename[data.AnimationVersionId]?.[data.AnimationCodename];

			this.setAnimationStep(data.AnimationStepVersionId, data.AnimationStepScreenCodename, data.AnimationStepAnimationCodename, animationStep);

			this.detectAnimationStepChanges(oldAnimationStep, animationStep);

		}

	},

	init() {

		this.AnimationsByVersionByCodename = {};
		this.AnimationStepsByScreenByCodename = {};

	},

	setAnimations(versionsScreensAnimations) {

		_.each(versionsScreensAnimations, (versionScreensAnimations, versionId) => {

			_.each(versionScreensAnimations, (versionScreenAnimations, screenCodename) => {

				_.each(versionScreenAnimations, versionScreenAnimation => {

					this.setAnimation(versionId, screenCodename, versionScreenAnimation);

				});

			});

		});

	},

	setAnimation(versionId, screenCodename, animation) {

		if (!this.AnimationsByVersionByCodename[versionId]) this.AnimationsByVersionByCodename[versionId] = {};
		if (!this.AnimationsByVersionByCodename[versionId][screenCodename]) this.AnimationsByVersionByCodename[versionId][screenCodename] = {};

		this.AnimationsByVersionByCodename[versionId][screenCodename][animation.codename] = animation;

	},

	detectAnimationChanges(oldAnimation, newAnimation) {

		//TODO:

	},

	setAnimationSteps(versionsScreensAnimationsSteps) {

		_.each(versionsScreensAnimationsSteps, (versionScreensAnimationsSteps, versionId) => {

			_.each(versionScreensAnimationsSteps, (versionScreenAnimationsSteps, screenCodename) => {

				_.each(versionScreenAnimationsSteps, (versionScreenAnimationSteps, animationCodename) => {

					_.each(versionScreenAnimationSteps, versionScreenAnimationStep => {

						this.setAnimationStep(versionId, screenCodename, animationCodename, versionScreenAnimationStep);

					});

				});

			});

		});

	},

	setAnimationStep(versionId, screenCodename, animationCodename, animationStep) {

		if (!this.AnimationStepsByScreenByCodename[versionId]) this.AnimationStepsByScreenByCodename[versionId] = {};
		if (!this.AnimationStepsByScreenByCodename[versionId][screenCodename]) this.AnimationStepsByScreenByCodename[versionId][screenCodename] = {};
		if (!this.AnimationStepsByScreenByCodename[versionId][screenCodename][animationCodename]) this.AnimationStepsByScreenByCodename[versionId][screenCodename][animationCodename] = {};

		this.AnimationStepsByScreenByCodename[versionId][screenCodename][animationCodename][animationStep.id] = animationStep;

	},

	detectAnimationStepChanges(oldAnimation, newAnimation) {

		//TODO:

	},

	getVersionAnimations(version) {

		return this.AnimationsByVersionByCodename[version.id];

	},

	getVersionAnimationSteps(version) {

		return this.AnimationStepsByScreenByCodename[version.id];

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.AnimationService) Animation = window.AnimationService;
else window.AnimationService = Animation;

export { Animation }

